/** Browser-specific messages thrown when native `fetch` cannot complete a request. */
export const FETCH_CONNECTION_ERROR_MESSAGES = [
  'Network request failed',
  'Failed to fetch',
  'NetworkError when attempting to fetch resource.',
  'Load failed',
] as const;

/**
 * Returns true when `reason` is a fetch-level connection failure (e.g. offline, blocked by an extension).
 */
export function isFetchConnectionError(reason: unknown): reason is TypeError {
  return (
    reason instanceof TypeError &&
    (FETCH_CONNECTION_ERROR_MESSAGES as ReadonlyArray<string>).includes(reason.message)
  );
}
